// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailTemplate_root__OVy9D {
  max-width: 1500px;
  margin-right: 10px;
  padding: 15px;
  color: var(--color-font-10);
  overflow: scroll;
  height: 100%;
}

.EmailTemplate_template_setup__DAQeo {
  min-height: 101px;
  display: flex;
  justify-content: space-between;
}

.EmailTemplate_letter_setup__Y7Eul {
  display: flex;
  justify-content: space-between;
}

.EmailTemplate_confirm_btn__nL9mR {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 100%;
  height: 41px;
  font-weight: bold !important;
  margin: 5px 0px !important;
}

.EmailTemplate_btn_cancel__71ZPA {
  width: 100% !important;
}

.EmailTemplate_template_action_container__4WPaQ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 11px;
}

.EmailTemplate_template_days_container__\\+nMhM {
  width: 20%;
  min-width: 170px;
}

.EmailTemplate_template_days_container__\\+nMhM p {
  font-size: 14px !important;
}

.EmailTemplate_template_col__ZSeyX {
  width: 70%;
  display: flex;
  padding: 0px 20px 0px 0px;
  height: 65vh;
  flex-direction: column;
}

.EmailTemplate_template_container__tBtyl {
  display: flex;
}

.EmailTemplate_placeholder_col__0yq3a {
  border: 0.5px solid;
  width: 230px;
  border-radius: 4px;
  border-color: var(--color-theme-gray-white);
  margin-top: 16px;
  margin-bottom: 8px;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-height: 100%;
}
.EmailTemplate_placeholder_info_container__BmsZv {
  padding: 10px 0px;
  overflow-y: auto;
  background-color: var(--color-bg-caselist);
  border-radius: 4px;
  width: 100%;
}

.EmailTemplate_placeholder_scrollbar__aEfeF {
  width: 86% !important;
}

.EmailTemplate_placeholder_info_container__BmsZv > * {
  margin-left: 10% !important;
}

.EmailTemplate_template_text_content__EVOhQ::-webkit-scrollbar {
  width: 8px !important;
  display: inherit !important;
  background-color: white !important;
}

.EmailTemplate_template_text_content__EVOhQ::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0px !important;
  display: inherit !important;
  width: 10px !important;
}

.EmailTemplate_placeholder_info_container__BmsZv::-webkit-scrollbar {
  width: 8px !important;
  display: inherit !important;
  background-color: white !important;
}

.EmailTemplate_placeholder_info_container__BmsZv::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0px !important;
  display: inherit !important;
  width: 10px !important;
}

/* placeholders */
.EmailTemplate_placeholder_group__dBVqU {
  margin: 7px;
}

.EmailTemplate_placeholder_item__JaqGu p {
  font-size: 14px !important;
  display: inline-block;
  clear: both;
  border: 1px solid var(--color-theme-cloud);
  border-radius: 15px;
  padding: 0px 10px;
  margin: 5px;
}

.EmailTemplate_placeholder_enabled__ijmkt p {
  color: var(--color-theme-blue);
}

.EmailTemplate_placeholder_item__JaqGu p:hover {
  background-color: var(--color-theme-lightblue);
  border: 1px solid var(--color-theme-blue);
}

.EmailTemplate_tooltip_title__9UVO7 {
  font-size: 13px !important;
}

.EmailTemplate_placeholder_disabled__ifGql p {
  color: var(--color-theme-cloud);
}

.EmailTemplate_hidden__A7MFn {
  visibility: hidden;
}

.EmailTemplate_template_text_container__Jz97X {
  width: 35%;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/EmailTemplate/EmailTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".root {\n  max-width: 1500px;\n  margin-right: 10px;\n  padding: 15px;\n  color: var(--color-font-10);\n  overflow: scroll;\n  height: 100%;\n}\n\n.template_setup {\n  min-height: 101px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.letter_setup {\n  display: flex;\n  justify-content: space-between;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 100%;\n  height: 41px;\n  font-weight: bold !important;\n  margin: 5px 0px !important;\n}\n\n.btn_cancel {\n  width: 100% !important;\n}\n\n.template_action_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 11px;\n}\n\n.template_days_container {\n  width: 20%;\n  min-width: 170px;\n}\n\n.template_days_container p {\n  font-size: 14px !important;\n}\n\n.template_col {\n  width: 70%;\n  display: flex;\n  padding: 0px 20px 0px 0px;\n  height: 65vh;\n  flex-direction: column;\n}\n\n.template_container {\n  display: flex;\n}\n\n.placeholder_col {\n  border: 0.5px solid;\n  width: 230px;\n  border-radius: 4px;\n  border-color: var(--color-theme-gray-white);\n  margin-top: 16px;\n  margin-bottom: 8px;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n  max-height: 100%;\n}\n.placeholder_info_container {\n  padding: 10px 0px;\n  overflow-y: auto;\n  background-color: var(--color-bg-caselist);\n  border-radius: 4px;\n  width: 100%;\n}\n\n.placeholder_scrollbar {\n  width: 86% !important;\n}\n\n.placeholder_info_container > * {\n  margin-left: 10% !important;\n}\n\n.template_text_content::-webkit-scrollbar {\n  width: 8px !important;\n  display: inherit !important;\n  background-color: white !important;\n}\n\n.template_text_content::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0px !important;\n  display: inherit !important;\n  width: 10px !important;\n}\n\n.placeholder_info_container::-webkit-scrollbar {\n  width: 8px !important;\n  display: inherit !important;\n  background-color: white !important;\n}\n\n.placeholder_info_container::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0px !important;\n  display: inherit !important;\n  width: 10px !important;\n}\n\n/* placeholders */\n.placeholder_group {\n  margin: 7px;\n}\n\n.placeholder_item p {\n  font-size: 14px !important;\n  display: inline-block;\n  clear: both;\n  border: 1px solid var(--color-theme-cloud);\n  border-radius: 15px;\n  padding: 0px 10px;\n  margin: 5px;\n}\n\n.placeholder_enabled p {\n  color: var(--color-theme-blue);\n}\n\n.placeholder_item p:hover {\n  background-color: var(--color-theme-lightblue);\n  border: 1px solid var(--color-theme-blue);\n}\n\n.tooltip_title {\n  font-size: 13px !important;\n}\n\n.placeholder_disabled p {\n  color: var(--color-theme-cloud);\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.template_text_container {\n  width: 35%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmailTemplate_root__OVy9D`,
	"template_setup": `EmailTemplate_template_setup__DAQeo`,
	"letter_setup": `EmailTemplate_letter_setup__Y7Eul`,
	"confirm_btn": `EmailTemplate_confirm_btn__nL9mR`,
	"btn_cancel": `EmailTemplate_btn_cancel__71ZPA`,
	"template_action_container": `EmailTemplate_template_action_container__4WPaQ`,
	"template_days_container": `EmailTemplate_template_days_container__+nMhM`,
	"template_col": `EmailTemplate_template_col__ZSeyX`,
	"template_container": `EmailTemplate_template_container__tBtyl`,
	"placeholder_col": `EmailTemplate_placeholder_col__0yq3a`,
	"placeholder_info_container": `EmailTemplate_placeholder_info_container__BmsZv`,
	"placeholder_scrollbar": `EmailTemplate_placeholder_scrollbar__aEfeF`,
	"template_text_content": `EmailTemplate_template_text_content__EVOhQ`,
	"placeholder_group": `EmailTemplate_placeholder_group__dBVqU`,
	"placeholder_item": `EmailTemplate_placeholder_item__JaqGu`,
	"placeholder_enabled": `EmailTemplate_placeholder_enabled__ijmkt`,
	"tooltip_title": `EmailTemplate_tooltip_title__9UVO7`,
	"placeholder_disabled": `EmailTemplate_placeholder_disabled__ifGql`,
	"hidden": `EmailTemplate_hidden__A7MFn`,
	"template_text_container": `EmailTemplate_template_text_container__Jz97X`
};
export default ___CSS_LOADER_EXPORT___;
